var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import DropdownSearch from './DropdownSearch';
import RuleFrame from './shared/RuleFrame';
var AddPredicate = function (_a) {
    var contextPlugins = _a.contextPlugins, newNodeId = _a.newNodeId, addPredicate = _a.addPredicate, uiBlocks = _a.uiBlocks;
    var WRAPPER_CLASS = 'rule-frame';
    var DEFAULT_CLASS = 'rule-add';
    var _b = __read(useState(false), 2), isSearching = _b[0], setIsSearching = _b[1];
    var selectItem = function (ctxPlugin, attrKey) {
        addPredicate(ctxPlugin, attrKey, newNodeId, null);
        setIsSearching(false);
    };
    var cancelSearch = function () {
        setIsSearching(false);
    };
    return (React.createElement(RuleFrame, { renderProps: {
            isLastBlock: true,
            isExpanded: true,
        } },
        React.createElement("div", { className: "".concat(WRAPPER_CLASS, "__flex ").concat(DEFAULT_CLASS) }, isSearching ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "".concat(WRAPPER_CLASS, "__title") },
                React.createElement("span", { className: "".concat(WRAPPER_CLASS, "__title__nodeId") }, +newNodeId)),
            React.createElement(DropdownSearch, { className: "".concat(DEFAULT_CLASS), contextPlugins: contextPlugins, onSelect: selectItem, onCancel: cancelSearch, uiBlocks: uiBlocks }))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "".concat(WRAPPER_CLASS, "__title ").concat(DEFAULT_CLASS), onClick: function () { return setIsSearching(true); } },
                React.createElement("span", { className: "".concat(WRAPPER_CLASS, "__title__nodeId") }, "+")),
            React.createElement("span", { className: "".concat(WRAPPER_CLASS, "__ruleName ").concat(DEFAULT_CLASS), onClick: function () { return setIsSearching(true); } }, "Add condition"))))));
};
export default AddPredicate;
//# sourceMappingURL=AddPredicate.js.map